import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { db, firebaseStore } from './../../config/firebaseConfig';
import { client } from './../../contentful/contentful';

const JobPost = () => {

  const [subcribeEmail,setSubscribeEmail] = useState('');
  const [disableBtn,setDisableBtn] = useState(false);
  const [emailSubmitted,setEmailSubmitted] = useState(false);
  const [formSubmitted,setFormSubmitted] = useState(false);
  const [emailSubscribeError,setEmailSubcribeError] = useState("");
  const [validationErrorMessage,setValidationErrorMessage] = useState("");
  const [name,setName] = useState("");
  const [email,setEmail] = useState("");
  const [phone,setPhone] = useState("");
  const [linkedIn,setLinkedIn] = useState("");
  const [portfolio,setPortfolio] = useState("");
  const recaptchaRef = useRef("");
  const [file,setFile] = useState("");
  const [uploadValue,setUploadValue] = useState(0);
  let form = document.getElementById("contactForm1");
  const [loading,setLoading] = useState(false);
  const [job,setJob] = useState({});

  useEffect( ()=>{
    try {
      setLoading(true);
      client.getEntries({
        'content_type': 'jobPosting'
      }).then( response =>{
          let items = response.items;
          const entries = items.filter( job => job.sys.id === getEntryIDFromURL[6] );
          if(entries.length === 0){
            setJob({});
          }else{
            setJob(entries[0]);
          }
          setLoading(false);
      });
      let getEntryIDFromURL = window.location.href.split('/');
      window.scrollTo(0, 0);
    } catch (error) {
      console.log('error obteniendo posts ' + error);
    }
  },[] );

  const saveEmail = async () =>{
    if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(subcribeEmail))){
        setEmailSubcribeError("Error: Debe ingresar un email válido");
        setDisableBtn(false);
        return;
    }
    setEmailSubcribeError("");
    await db.collection('jobs-newsletter').doc().set({
      email : subcribeEmail
    }).then(response =>{
      setDisableBtn(false);
      setSubscribeEmail("");
      setEmailSubmitted(true);
      setTimeout( ()=>{
        setEmailSubmitted(false);
      },3000);
    });
  }

  const handleSubcribe = (e) =>{
    try {
      e.preventDefault();
      setDisableBtn(true);
      saveEmail();
    } catch (error) {
      console.log('Error al enviar correo' + error );
    }
  }

  const handleOnChangeFile = (e) =>{
    let file = e.target.files[0];
    setFile(file);
  }

  
  const formValidations = () => {

    const initialNumber = phone.charAt(0);
    const threeFirstsNumber = phone.substr(0,3);
    const nineRemainNumbers = phone.substr(3);
    const recaptchaValue = recaptchaRef.current;
    if(name === "" ){
        setValidationErrorMessage("Error: Campo nombre y apellido obligatorio");
        setDisableBtn(false);
        return false;
    };
    if(email === ""){
        setValidationErrorMessage("Error: Campo email obligatorio");
        setDisableBtn(false);
        return false;
    };
    if(phone === "" ){
        setValidationErrorMessage("Error: Campo teléfono obligatorio");
        setDisableBtn(false);
        return false;
    };
    if(linkedIn === "" ){
        setValidationErrorMessage("Error: Campo linkedIn obligatorio");
        setDisableBtn(false);
        return false;
    };
    if(file === "" ){
        setValidationErrorMessage("Error: La hoja de vida es obligatoria");
        setDisableBtn(false);
        return false;
    };
    if(recaptchaValue.getValue() === ''){
        setValidationErrorMessage("Error: verifica que no eres un robot");
        setDisableBtn(false);
        return false;
    }
    if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))){
        setValidationErrorMessage("Error: Ingresa un correo válido");
        setDisableBtn(false);
        return false;
    }
    if(isNaN(phone)){
        setValidationErrorMessage("Error: Se debe digitar un numero válido");
        setDisableBtn(false);
        return false;
    }
    if (initialNumber === '0' && !(phone.length === 10)){
        setValidationErrorMessage("Error: El número telefónico debe tener 10 dígitos");
        setDisableBtn(false);
        return false;
    }else if(threeFirstsNumber === '593' && !(nineRemainNumbers.length === 9)){
        setValidationErrorMessage("Error: El número telefónico debe tener 9 dígitos apartir del 593");
        setDisableBtn(false);
        return false;
    }
    recaptchaValue.reset();
    setValidationErrorMessage("");
    return true;
  }


  const saveForm = async () =>{
    if (!formValidations()) return;
    setValidationErrorMessage("");
    const firebaseRef = firebaseStore.ref(`cv/${file.name}`);
    const task = firebaseRef.put(file);
    let downloadURL = '';
    task.on('state_changed', (snapshot) =>{
        let percentage = (snapshot.bytesTransferred / snapshot.totalBytes ) * 100;
        setUploadValue(percentage);
    } , (error)=>{
      setValidationErrorMessage('Ha ocurrido un error');
      setDisableBtn(false);
    }, async () =>{
      downloadURL = await task.snapshot.ref.getDownloadURL();
      await db.collection('job-application').doc().set({
        name,
        email,
        phone,
        linkedIn,
        file : downloadURL,
        portfolio,
        jobID: job.sys.id
      }).then(response =>{
        setDisableBtn(false);
        setFormSubmitted(true);
        setName("");
        setEmail("");
        setPhone("");
        setLinkedIn("");
        setPortfolio("");
        setFile("");
        setUploadValue(0);
        form.reset();
        setTimeout( ()=>{
          setFormSubmitted(false);
        },3000);
      });
    })
  }

  const handleSubmit = (e) =>{
    try {
      e.preventDefault();
      setDisableBtn(true);
      saveForm();
    } catch (error) {
      console.log('Error al enviar correo' + error );
    }
  }

  return ( 
    <React.Fragment>
      <div className="module ptb-100">
        {
          loading ?
            <div className="container">
              <div className="row">
                <div className="col d-flex justify-content-center my-5">
                  <div class="spinner-border text-danger" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </div> :
            <div className="container">
              <div className="row">
                <div className=" col-sm-12 col-lg-4 col-md-4">
                  <div className="sidebar-left pr-4">
                    <aside className="widget widget-categories">
                          <div className="widget-title">
                              <h6>Newsletter</h6>
                          </div>
                          <p>
                              Enter your email address below to subscribe to my
                              newsletter
                          </p>
                          <form
                              action="/#"
                              method="job"
                              className="d-none d-md-block d-lg-block"
                              onChange={ (e) => setSubscribeEmail(e.target.value) }
                              onSubmit={ e => handleSubcribe(e) }
                          >
                              <input
                              type="text"
                              className="form-control input"
                              id="email-footer"
                              name="email"
                              placeholder="info@yourdomain.com"
                              value={subcribeEmail}
                              />
                              <button
                              type="submit"
                              className="btn solid-btn btn-block btn-not-rounded mt-3"
                              disabled={disableBtn}
                              >
                              Subscribe
                              </button>
                          </form>
                          { emailSubmitted ? <span class="badge badge-pill badge-success ml-3 badgeNewsLetter position-static">Enviado!</span>:null}
                          { emailSubscribeError !== "" ? emailSubscribeError : null}
                      </aside>
                  </div>
                </div>
                {
                    job.fields ?
                    <div className="col-lg-8 col-md-8">
                      <article className="post">
                        <div className="post-preview">
                          <a href="#">
                            <img src={(job.fields.cover.fields.file.url) || `${process.env.PUBLIC_URL}/img/blog/2-w.jpg` } alt="blog" />
                          </a>
                        </div>
                        <div className="post-wrapper">
                          <div className="post-header">
                            <h2 className="post-title">
                              <a href="#">
                              {(job.fields.title)}
                              </a>
                            </h2>
                            <ul className="post-meta">
                              <li>{format( new Date(job.fields.date),'MMM dd yyyy')}</li>
                              <li>
                                {job.fields.department}
                              </li>
                            </ul>
                          </div>
                          <div className="post-content">
                            <p>
                              {documentToReactComponents(job.fields.description)}
                            </p>
                          </div>
                        </div>
                      </article>
                      <form
                        method="POST"
                        id="contactForm1"
                        className="contact-us-form"
                        onSubmit={e => handleSubmit(e)}
                        >
                        <h5>Envia tu solicitud</h5>
                        <div className="row">
                            <div className="col-sm-6 col-12">
                            <div className="form-group">
                                <input
                                value={name}
                                onChange={e => setName(e.target.value)}
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Nombre y Apellido"
                                />
                            </div>
                            </div>
                            <div className="col-sm-6 col-12">
                              <div className="form-group">
                                  <input
                                  value={email}
                                  onChange={e => setEmail(e.target.value)}
                                  type="text"
                                  className="form-control"
                                  name="email"
                                  placeholder="E-mail"
                                  />
                              </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 col-12">
                                <div className="form-group">
                                    <input
                                    value={phone}
                                    onChange={e => setPhone(e.target.value)}
                                    type="number"
                                    name="phone"
                                    className="form-control"
                                    id="phone"
                                    placeholder="Teléfono / WhatsApp"
                                    />
                                </div>
                          </div>
                          <div className="col-sm-6 col-12">
                                <div className="form-group">
                                    <input
                                    onChange={e => handleOnChangeFile(e)}
                                    type="file"
                                    name="file"
                                    className="form-control"
                                    id="file"
                                    placeholder="Selecciona archivo"
                                    />
                                </div>
                          </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 col-12">
                              <div className="form-group">
                                  <input
                                  value={linkedIn}
                                  onChange={e => setLinkedIn(e.target.value)}
                                  type="text"
                                  className="form-control"
                                  name="linkedIn"
                                  placeholder="LinkedIn"
                                  />
                              </div>
                            </div>
                            <div className="col-sm-6 col-12">
                              <div className="form-group">
                                  <input
                                  value={portfolio}
                                  onChange={e => setPortfolio(e.target.value)}
                                  type="text"
                                  className="form-control"
                                  name="porfolio"
                                  placeholder="Portafolio web"
                                  />
                              </div>
                            </div>
                        </div>
                        <div className="row d-flex flex-row-reverse pr-5">
                          <progress value={uploadValue} max='100'>
                          {uploadValue} %
                          </progress>
                        </div>
                        <div className="row">
                            <div className="col mt-2">
                              <button
                                  type="submit"
                                  className="btn solid-btn"
                                  id="btnContactUs"
                                  disabled={disableBtn}
                              >
                                  Enviar formulario
                              </button>
                            </div>
                            <div className="col mt-1 d-flex justify-content-center">
                            <ReCAPTCHA
                              ref={this.recaptchaRef}
                              size={'compact'}
                              sitekey={ 
                                process.env.NODE_ENV === "development" ? 
                                process.env.REACT_APP_SITE_KEY_LOCAL_RECAPTCHA :
                                process.env.REACT_APP_SITE_KEY_PROD_RECAPTCHA
                              }
                              onChange={this.onChange}
                            />
                            </div>
                        </div>
                        </form>
                      { formSubmitted ? <span class="badge badge-pill badge-success ml-3 badgeNewsLetter position-static">Enviado!</span>:null}
                      { validationErrorMessage !== "" ? validationErrorMessage : null}  
                    </div>
                    :
                    <div className="col-lg-8 col-md-8">
                      <article className="job">
                          <div className="job-wrapper">
                              <div className="job-header">
                                  <p className="job-title w-50 mx-auto">Ops! no hay vacante a mostrar</p>
                              </div>
                          </div>
                      </article>
                    </div>
                }
              </div>
            </div>
        }
      </div>
    </React.Fragment>
  );
}
 
export default JobPost;
